import { render, staticRenderFns } from "./Header.LanguageSelector.vue?vue&type=template&id=7081731c&scoped=true&"
import script from "./Header.LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./Header.LanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./Header.LanguageSelector.vue?vue&type=style&index=0&id=7081731c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081731c",
  null
  
)

component.options.__file = "Header.LanguageSelector.vue"
export default component.exports